import { gql } from '@apollo/client';

export const GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM = gql`
  query getTagesDatenByStandortIdAndZeitraum(
    $standortIds: [String!]!
    $zeitraum: ZeitraumInput!
  ) {
    termine_kalenderTagesDatenByStandortIdAndZeitraum(
      standortIds: $standortIds
      zeitraum: $zeitraum
    ) {
      termine {
        ... on termine_termine {
          id
          titel
          datum
          beginn
          ende
          standortId
          terminKalenderId
          image {
            name
            contentType
            url
            thumbnailUrl
          }
          markierung
          termineDetails {
            beschreibung
            specials
          }
          wiederholung
          wiederholungBis
        }
        ... on termine_termineError {
          message
        }
      }
      feiertage {
        name
        datum
      }
    }
  }
`;
